import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { __mapOfCondition } from '../../../node_modules/aws-sdk/clients/guardduty';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { PasswordPolicy } from '../types/password-policy';
import { SessionStorageService } from './session-storage.service';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root'
})
export class PasswordPolicyService {
  cognitoPolicy: PasswordPolicy;

  constructor(private log: LogService,private http: HttpClient, private storageService: SessionStorageService) {}

  validate(password: string, password_confirm?: string): string {
    if (password_confirm && password !== password_confirm) {
      return 'Passwords don\'t match, please try again.';
    }

    // Let all other validity checking happen at AWS, and determine which policy aspect failed
    // afterward by querying for the password policy and checking the password against it.
    return null;
  }

  clearPasswordPolicy() {
    this.cognitoPolicy = null;
  }

  getPasswordPolicy(
    userPoolId?: string,
    username?: string
  ): Observable<PasswordPolicy> {
    if (this.cognitoPolicy) {
      return of(this.cognitoPolicy);
    } else {
      const payload = _.omitBy({
        userPoolId: userPoolId,
        username: username,
        uuxSessionId: this.storageService.getUUXSessionId()
      }, _.isNil);
      return this.http
        .post(`${environment.api.describeUserPool}`, payload)
        .pipe(
          map((results: any) => {
            if (results.Policies != null){
              this.log.trace('Password Policies not null');
              this.cognitoPolicy = new PasswordPolicy(
                results.Policies.PasswordPolicy
              );
            }else{
              this.log.trace('Password Policies null');
              this.cognitoPolicy = new PasswordPolicy(
                null
              );
            }
            
            return this.cognitoPolicy;
          })
        );
    }
  }
}
